"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    fontFamily,
    basicFontSize,
    themeColors,
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    getMeasurement
  } = (0, _hooks.useStylesUtils)();
  const {
    layout = 'popup',
    isOpen = false,
    zIndex = 9999,
    type,
    width = '666',
    height = 'auto'
  } = props;
  const ccModalStyle = (0, _react.useMemo)(() => {
    const containerMobileProps = () => {
      if (isMobileView) {
        return {
          height: '100%'
        };
      }
      return {};
    };
    const blockerLayoutMobileProps = () => {
      if (layout === 'popup') {
        return {
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: zIndex,
          transition: 'opacity 0.6s ease',
          opacity: isOpen ? 1 : 0
        };
      }
      return {};
    };
    const layoutTypeMobileProps = () => {
      if (layout === 'popup') {
        let popupProps;
        if (isMobileView) {
          popupProps = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '100%'
          };
        } else {
          popupProps = {
            top: pxToRem(31),
            left: '50%',
            transform: 'translateX(-50%)',
            width: getMeasurement(width),
            height: getMeasurement(height),
            maxWidth: `calc(100% - ${pxToRem(45)})`,
            maxHeight: `calc(100% - ${pxToRem(62)})`,
            borderRadius: pxToRem(10)
          };
        }
        let outline = 'none';
        if (!isMobileView) {
          switch (type) {
            case 'alert':
              outline = `${pxToRem(2)} solid ${themeColors?.general.alert};`;
              break;
            case 'success':
              outline = `${pxToRem(2)} solid ${themeColors?.general.success};`;
              break;
            default:
              outline = 'none';
              break;
          }
        }
        return {
          position: 'fixed',
          display: 'flex',
          flexFlow: 'column',
          backgroundColor: '#fff',
          outline: outline,
          zIndex: zIndex,
          ...popupProps
        };
      } else {
        if (isMobileView) {
          return {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          };
        }
        return {};
      }
    };
    const closeBtnDirectionMobileProps = () => {
      let left;
      let right;
      const top = isMobileView ? pxToRem(12) : pxToRem(-18);
      if (direction === 'rtl') {
        left = isMobileView ? pxToRem(14) : pxToRem(-18);
        right = 'auto';
      } else {
        right = isMobileView ? pxToRem(14) : pxToRem(-18);
        left = 'auto';
      }
      return {
        top,
        left,
        right
      };
    };
    const ccModalContainer = (0, _css.css)({
      fontFamily: fontFamily,
      fontSize: basicFontSize,
      ...containerMobileProps()
    });
    const ccModalBlocker = (0, _css.css)({
      ...blockerLayoutMobileProps()
    });
    const ccModal = (0, _css.css)({
      color: themeColors?.general.text,
      border: 0,
      padding: 0,
      margin: 0,
      insetInlineStart: 'auto',
      insetInlineEnd: 'auto',
      ...layoutTypeMobileProps()
    });
    const ccModalCloseBtn = (0, _css.css)({
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: zIndex,
      ...closeBtnDirectionMobileProps()
    });
    return {
      ccModalContainer,
      ccModalBlocker,
      ccModal,
      ccModalCloseBtn
    };
  }, [basicFontSize, direction, fontFamily, getMeasurement, height, isMobileView, isOpen, layout, pxToRem, themeColors?.general.alert, themeColors?.general.success, themeColors?.general.text, type, width, zIndex]);
  return {
    'cc-Modal-container': ccModalStyle.ccModalContainer,
    'cc-Modal-blocker': ccModalStyle.ccModalBlocker,
    'cc-Modal': ccModalStyle.ccModal,
    'cc-Modal__close-btn': ccModalStyle.ccModalCloseBtn
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;